import {Nullable} from './app/TypeHelpers'
import {numberOrNull} from './stringHelper/stringHelpers'

export const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'
export const KEY_AUTHORITIES: string = 'AUTHORITIES'
export const KEY_LOGIN_MODE: string = 'loginMode'
export const KEY_ROLE: string = 'role'

export class SessionStorageHelper {
    static getNumberItemOrNull(key: string): Nullable<number> {
        const value: Nullable<string> = window.sessionStorage.getItem(key)
        return value ? numberOrNull(value) : null
    }

    static getStringItemOrNull(key: string): Nullable<string> {
        return window.sessionStorage.getItem(key)
    }

    static getNumberItemWithDefault(key: string, defaultValue: number): number {
        const value: Nullable<number> = SessionStorageHelper.getNumberItemOrNull(key)
        return value ? value : defaultValue
    }

    static getStringItemWithDefault(key: string, defaultValue: string): string {
        const value: Nullable<string> = SessionStorageHelper.getStringItemOrNull(key)
        return value ? value : defaultValue
    }

    static setItem(key: string, value: number | string): void {
        window.sessionStorage.setItem(key, `${value}`)
    }

    static removeItem(key: string): void {
        window.sessionStorage.removeItem(key)
    }

    static removeAllItem(): void {
        const value: Nullable<string> = SessionStorageHelper.getStringItemOrNull('isSutekiNetSmartPhoneApplication')
        window.sessionStorage.clear()

        if (value) {
            SessionStorageHelper.setItem('isSutekiNetSmartPhoneApplication', value)
        }
    }

    static existsAnyItem(): boolean {
        return window.sessionStorage.length > 0
    }

    static setObject<T extends object>(key: string, value: T): void {
        SessionStorageHelper.setItem(key, JSON.stringify(value))
    }

    static getObject<T extends object>(key: string): Nullable<T> {
        const item = SessionStorageHelper.getStringItemOrNull(key)
        return item ? JSON.parse(item) : null
    }
}
